import { render, staticRenderFns } from "./UserManagementEditTabGeneral.vue?vue&type=template&id=abdc02a6&"
import script from "./UserManagementEditTabGeneral.vue?vue&type=script&lang=js&"
export * from "./UserManagementEditTabGeneral.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementEditTabGeneral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports